import React, { useEffect } from 'react'
import "./Turntable_Activity_details_table.css";
import { useDispatch, useSelector } from 'react-redux';
import { GetTurntableDash } from '../../../../features/spin/Slice';
import { AllTurnTableRule } from '../../../../features/admin/common/Slice';
import { formatAmount } from '../../../../utils/common';

function Turntable_Activity_details_table() {

    const dispatch = useDispatch()

    const turntable_rules = useSelector((state) => state.common.all_turntable_rule);

    console.log({ turntable_rules });

    useEffect(() => { dispatch(AllTurnTableRule()) }, [dispatch]);
    return (
        <>
            <section className='Turntable_Activity_details_table'>

                <div className='Game_History'>

                    <table className='table_wrapper'>

                        <thead>
                            <tr>
                                <th>Task</th>
                                <th>Number of spins</th>
                                <th>spin time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {turntable_rules?.length > 0
                                && turntable_rules?.map((data) => (
                                    <tr>
                                        <td> <span className='targetAmount' >{formatAmount(data?.amount)}</span> <br />Total DepositBalance</td>
                                        <td>+{data?.spins}</td>
                                        <td>00:00-23:59</td>
                                    </tr>
                                ))}



                        </tbody>
                    </table>
                </div>

            </section>
        </>
    )
}

export default Turntable_Activity_details_table